export const ANALYTICS_SESSION_STORAGE_KEY = "trybraintest_analytics_session_id";

export type FunnelAnalyticsEventType = "test_started" | "test_completed";

function isBlockedPath(pathname: string) {
  return pathname === "/admin" || pathname.startsWith("/admin/") || pathname === "/dev" || pathname.startsWith("/dev/");
}

function safePath() {
  if (typeof window === "undefined") return "/";
  const pathname = window.location.pathname || "/";
  if (isBlockedPath(pathname)) return null;
  if (pathname.startsWith("/report/")) return "/report/[report]";
  return pathname;
}

export function getAnalyticsSessionId() {
  if (typeof window === "undefined") return undefined;
  return localStorage.getItem(ANALYTICS_SESSION_STORAGE_KEY) ?? undefined;
}

export function storeAnalyticsSessionId(sessionId: string | undefined) {
  if (typeof window === "undefined" || !sessionId) return;
  localStorage.setItem(ANALYTICS_SESSION_STORAGE_KEY, sessionId);
}

export async function trackAnalyticsEvent(
  eventType: FunnelAnalyticsEventType,
  ids: { attemptId?: string; orderId?: string; reportId?: string } = {},
  metadata?: Record<string, string | number | boolean | null>
) {
  const path = safePath();
  if (!path) return;

  const response = await fetch("/api/analytics/track", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      sessionId: getAnalyticsSessionId(),
      eventType,
      path,
      ...ids,
      metadata
    }),
    keepalive: true
  }).catch(() => null);

  if (!response?.ok) return;
  const data = (await response.json().catch(() => null)) as { sessionId?: string } | null;
  storeAnalyticsSessionId(data?.sessionId);
}
